import { CalculatedBudget } from 'store/planStore';
import { OptionalIds } from 'shared/components/EstimatedBudgetsTable/types';

const addIsIncludedFlagToCalculatedBudget = (
  optionalIds: OptionalIds,
  calculatedBudget?: CalculatedBudget[]
) => {
  return calculatedBudget?.map((row) => {
    const key = `${row.touchpointName}${row.touchpointFunnel}`;

    const isIncludedInCalculations =
      row.isMandatory || optionalIds[key] || false;

    return {
      ...row,
      isIncludedInCalculations,
    };
  });
};

export default addIsIncludedFlagToCalculatedBudget;
